import { GlobalState, UI } from '@leverege/ui-redux';
import { GroupActions } from '@leverege/molten/imagine';
import PositionPendingButton from "./PositionPendingButton.js";
const getActions = actions => {
  return new GroupActions({
    ...actions,
    queryName: 'positionPendingCounter'
  });
};
const prepare = context => {
  let field;
  if (context.clientProps.objectType === 'assetLocators') {
    field = 'data/locator/data/pairedPositionPending';
  } else {
    field = 'data/pairedPositionPending';
  }
  return GlobalState.dispatch(getActions(context.clientProps.actions).search({
    limit: 0,
    aggs: {
      positionPendingAgg: {
        type: 'filter',
        filter: {
          field,
          type: 'equals',
          value: true
        }
      }
    }
  }));
};
const isPrepared = context => {
  if (!(context.clientProps.actions instanceof GroupActions)) {
    return true;
  }
  const prepared = getActions(context.clientProps.actions).isDone(GlobalState.get());
  return prepared;
};
const handles = context => {
  const {
    streetView
  } = context;
  const mapEditing = UI.get(GlobalState.get(), 'mapEditing');
  if (context.clientProps.item) {
    // only show on group screens, not item screns
    return false;
  }
  if (!(context.clientProps.actions instanceof GroupActions)) {
    return false;
  }
  const prepared = getActions(context.clientProps.actions).isDone(GlobalState.get());
  let pendingPositions = false;
  if (prepared) {
    const list = getActions(context.clientProps.actions).getList(GlobalState.get());
    pendingPositions = list.aggs.positionPendingAgg.count >= 1;
  }
  return prepared && pendingPositions && mapEditing !== true && !streetView;
};
export default {
  id: 'map.positionPendingButton',
  name: 'Positions Pending',
  matches: [{
    use: 'bottomLeftActionBar',
    client: ['MapDataViewer'],
    objectType: ['assetLocators', 'locator']
  }, {
    use: 'topLeftActionBar',
    client: ['GoogleMapsDataViewer'],
    objectType: ['assetLocators', 'locator']
  }],
  handles,
  prepare,
  isPrepared,
  customComponent: PositionPendingButton
};